// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/collaterals/archive',
        component: () =>
            import(/* webpackChunkName: "loans.issued-loan-collateral" */ '@/pages/[organisation]/loans/issued-loan-collateral/archived-issued-loan-collaterals.vue'),
        name: 'loans.issued-loan-collateral.archived-issued-loan-collaterals',
        meta: {
            loginRequired: true,
            permission: 'access.finance.loans.issued-loan-collateral.update-issued-loan-collateral',
        },
    },

    {
        path: ':id/collaterals',
        component: () =>
            import(/* webpackChunkName: "loans.issued-loan-collateral" */ '@/pages/[organisation]/loans/issued-loan-collateral/issued-loan-collaterals.vue'),
        name: 'loans.issued-loan-collateral.search-issued-loan-collaterals',
        meta: {
            loginRequired: true,
            permission: 'access.finance.loans.issued-loan-collateral.view-issued-loan-collaterals',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import(/* webpackChunkName: "loans.issued-loan-collateral" */ '@/pages/[organisation]/loans/issued-loan-collateral/issued-loan-collateral/new.vue'),
                name: 'loans.issued-loan-collateral.create-issued-loan-collateral',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan-collateral.create-issued-loan-collateral',
                },
            },
            {
                path: ':collateralId/edit',
                component: () =>
                    import(/* webpackChunkName: "loans.issued-loan-collateral" */ '@/pages/[organisation]/loans/issued-loan-collateral/issued-loan-collateral/[id]/edit.vue'),
                name: 'loans.issued-loan-collateral.update-issued-loan-collateral',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan-collateral.update-issued-loan-collateral',
                },
            },
        ],
    },
];
